import { api } from "../../../lib/api.js";

/**
 * Online Training MODULES (2026-11-02), through this app's BFF
 * (`/api/trainings/modules*` → portal-api `/api/v1/reseller/training_modules`).
 *
 * A module is one service or extension — Mass Notification, Audio
 * Conferencing — taught as short videos under a two-level menu: SECTIONS,
 * each with its LESSONS. Every topic with a video is a stop on the player's
 * back/next path (`playlist`, in play order). portal-api decides which
 * modules a company reads (the published ones).
 */
export type ModuleCategory = "service" | "extension";

export interface ModuleSummary {
  id: number;
  slug: string;
  title: string;
  summary: string | null;
  category: ModuleCategory;
  position: number;
  topic_count: number;
  total_duration_seconds: number;
  updated_at: string | null;
}

/**
 * What a topic plays. A LINK carries the documentation normalizer's
 * answer: `provider_url` is an iframe player (YouTube, Vimeo, Drive),
 * `direct_url` raw bytes for a native `<video>`. An uploaded FILE plays from
 * `src`, this app's own relay — never a portal-api address.
 */
export type TopicVideo =
  | {
      kind: "link";
      url: string;
      provider?: string | null;
      provider_url?: string | null;
      direct_url?: string | null;
      thumbnail?: string | null;
    }
  | { kind: "file"; src: string; filename: string; content_type: string | null; byte_size: number };

export interface ModuleTopic {
  id: number;
  parent_id: number | null;
  title: string;
  summary: string | null;
  position: number;
  duration_seconds: number | null;
  video: TopicVideo | null;
}

export interface ModuleSection extends ModuleTopic {
  lessons: ModuleTopic[];
}

export interface ModuleDetail extends ModuleSummary {
  sections: ModuleSection[];
  playlist: number[];
}

export async function listModules(): Promise<ModuleSummary[]> {
  const body = await api<{ data?: ModuleSummary[] }>("/api/trainings/modules");
  return Array.isArray(body.data) ? body.data : [];
}

export async function getModule(slug: string): Promise<ModuleDetail | null> {
  const body = await api<{ data?: ModuleDetail | null }>(`/api/trainings/modules/${encodeURIComponent(slug)}`);
  return body.data ?? null;
}
